import { AuxiliumComponent } from "../auxilium-component";

export default class Beacon extends AuxiliumComponent {
	static observable = ["size"];
	static observableBooleans = ["paused"];
}
